export default __webpack_public_path__ + "static/media/maher.8e65d1dc.jpeg";